<template>
    <div id="container" type="vdpp">
        <div class="page page-agenthome" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType:'vagenthome'}">
            <mvtHeader :geoInfo="geo"/>
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="agentCity.pageImage" alt="Welcome Movoto Agent Home" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <h1>
                        <b class="f0 text-bold">Connect with the best rated real estate agents in {{ geo.city }},  {{ geo.state }}</b>
                    </h1>
                    <div class="f5">We will match you with the best real estate agent in {{geo.city }}, {{ geo.state }} for your needs.</div>
                    <a href="javascript:;" @click="openHotlead" class="btn secondary regular">Connect with a Top Agent</a>
                </template>
            </mvtWelcome>
            <agentBar :data="agentBarOptions"></agentBar>
            <section id="topAgent" class="inline large">
                <div class="grid gap-3 sm-grid-cols-1 md-grid-cols-3 fixed fixed-max-sm">
                    <h2 class="wrap text-center"><b class="f3 text-bold">Learn more about our top-rated local {{ geo.city }} agents</b></h2>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-house"></span></div>
                        <div><b class="f4">The Best {{ geo.city }} Agents</b></div>
                        <div class="body">Partner with a Top-Rated {{ geo.city }} agent, with an average of 7+ years of experience, and ranked among the top 1% in the the Industry.</div>
                    </div>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-open-house"></span>
                        </div>
                        <div><b class="f4"> Exclusive Access To Listings</b></div>
                        <div class="body">Gain Access to exclusive off-market properties throughout {{ geo.city }}, providing you with a unique edge in your property search.</div>
                    </div>
                    <div class="large inline flex vertical left bg-default corner outline text-center">
                        <div><span class="f1 circle large default disabled icon-user"></span></div>
                        <div><b class="f4">Agents From The Best Brokerages</b></div>
                        <div class="body"> The best local agents from the most trusted brokerages near you, including Coldwell Banker, Keller Williams, Compass, Better Homes and Gardens, EXP, Century 21, RE/MAX, and more.</div>
                    </div>
                </div>
            </section>
            <section class="inline large" v-if="agentBarOptions.isSnapshotDataAvailable" id="snapshotPanel">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <mvtSnapshot :data="snapshotData"></mvtSnapshot>
                </div>
            </section>
            <agentTips class="bg-default inline large" id="agentTipsPanel"></agentTips>
            <agentWorkflow id="agentProcessPanel" :hotleadType="hotleadType"></agentWorkflow>
            <agentBanner class="inline bg-default large" :hotleadType="hotleadType"></agentBanner>
            <section class="inline large">
                <div class="grid gap-3 fixed fixed-max-sm top xs-grid-cols-1">
                    <agentConnect :hotleadType="hotleadType"></agentConnect>
                </div>
            </section>
            <section class="inline large" v-if="hasNewListings">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <div class="text-center">
                        <h2 class="f3 text-bold">
                            New homes for sale in <a :href="glb.appUrl + geo.newPath" class="link">{{ geo.city }}</a>
                        </h2>
                    </div>
                    <mvtLazyload ref="lazyload" :async="true" data-role="propertycard">
                        <mvtNearby type="city" filterPath="/new-7/" @completed="completed" carousalType="new"></mvtNearby>
                    </mvtLazyload>
                </div>
            </section>
            <agentTourlink class="inline large" id="agentToolLinkPanel"></agentTourlink>
            <agentBrokerage class="inline large" id="agentBrokeragePanel"></agentBrokerage>
            <brokerageBanner class="inline large bg-default"></brokerageBanner>
            <mvtFooter :geoInfo="geo"/>
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>
<script src="./page-agentsearch.js"></script>
<style lang="scss">
    @use './page-agentsearch.scss' as *;
</style>
